<template>
   <div>
        <div class="card-header">
            <p class="title-line1">Kết quả</p>
        </div>
        <div class="card-body">
            <div action="" class="info-submit m-auto text-center">
                <div class="result-block d-flex justify-content-between">
                    <div class="result-item">
                        <p>Listening: <span>{{testResult.listening.sumRightAnser}}/{{testResult.listening.sumQuestion}}</span></p>
                    </div>
                    <div class="result-item">
                        <p>Reading & Writing: <span>{{testResult.reading.sumRightAnser}}/{{testResult.reading.sumQuestion}}</span></p>
                    </div>
                </div>
                <div class="panel-tutorial">
                    <h4>Chúc mừng bạn nhỏ đã hoàn thành bài kiểm tra</h4>
          
                    <p class="bang-thanks">Peri cảm ơn và chúc bạn nhỏ có hành trình thật vui<br>và bổ ích với chúng mình nhé!</p>
                </div>
                
            </div>
        </div>
   </div>
</template>

<script>

import {
    BRow,
    BCol
} from 'bootstrap-vue'

export default {
    data() {
        return {
            timeRange: [
                { text: '14h - 15h', checked: false },
                { text: '15h - 16h', checked: false },
                { text: '16h - 17h', checked: false },
                { text: '17h - 18h', checked: false },
                { text: '18h - 19h', checked: false },
                { text: '19h - 20h', checked: false },
                { text: '21h - 22h', checked: false },
            ],
            testResult: {
                listening: {
                    sumQuestion: 0,
                    sumRightAnser: 0
                },
                reading: {
                    sumQuestion: 0,
                    sumRightAnser: 0
                },
            }
        }
    },
    components: {
        BRow,
        BCol
    },
    computed: {
        examId () {
            return this.$store.state.examId
        },
    },
    mounted () {
    },
    created() {
        this.getTestResult()
    },
    methods: {
        getTestResult () {
            this.$http.get('/get-result', {
                params: {
                    test_id: localStorage.getItem(`_speakup_exam${this.examId}`),
                }
            }).then(res => {
                if (res.data.code === 1) {
                    const resultResp = res.data.data
                    
                    if (resultResp[0]) {
                        this.testResult.listening = resultResp[0]
                    }
                    if (resultResp[1]) {
                        this.testResult.reading = resultResp[1]
                    }
                }
            })
        },
        timeCheck(index) {
            this.timeRange[index].checked = !this.timeRange[index].checked
        },
        pushData () {
            const trackid = localStorage.getItem('_speakup_track');

            let time = []

            for (let index = 0; index < this.timeRange.length; index++) {
                if (this.timeRange[index].checked) {
                    time.push(this.timeRange[index].text)
                }
                
            }

            if (trackid) {
                this.$http.post('/test-push-info', {
                        tracking_id: trackid,
                        test_id: localStorage.getItem(`_speakup_exam${this.examId}`),
                        data: {
                            time
                        }
                    }).then(res => {
                    if (res.data.code == 1) {
                        this.$store.commit('SET_PAGE', 5)
                    }
                })
            }
        },
    }
}
</script>

<style scoped>

.time-list {
    font-family: 'SFU Futura';
}

.checkbox {
    display: flex;
}

.checkbox .check-right {
    background-color: #fc7b32;
    color: #fff;
    border: 3px solid #e35707;
    font-size: 1.4rem;
    padding: 6px;
    border-radius: 14px;
    width: calc(100% - 67px);
    height: 52px;
}

.time-item {
    margin-bottom: 17px;
    cursor: pointer;
}

.title-line1 {
    font-family: 'iCiel Crocante';
    font-size: 2.5rem;
    color: #fc7b32;
}

.checkbox {
    display: flex;
}

.checkbox .check-left {
    border: 3px solid #e35707;
    width: 52px;
    height: 52px;
    border-radius: 14px;
    margin-right: 15px;
}

.result-block {
    margin-top: 20px;
}

.result-item {
    width: 45%;
    background-color: #4cac33;
    border: 2px solid #0a6620;
    color: #fff;
    font-family: 'FS Ariston Comic Base';
    font-size: 2.2rem;
    border-radius: 10px;
}

.result-item p {
    margin: 0;
}

.result-item p span {
    color: #fff000;
}


.panel-tutorial {
    padding: 50px;
    border-radius: 15px;
    border: 3px solid #0099ff;
    background-color: #fff;
    position: relative;
    margin-top: 40px;
}

.panel-tutorial h4 {
    font-family: 'FS Ariston Comic Base';
    color: #fc7b32;
    font-size: 2.8rem;
    margin-bottom: 40px;
}

.panel-tutorial p {
    font-family: 'Roboto-Medium';
    color: #0099ff;
    max-width: 724px;
    margin: auto;
    line-height: 2rem;
    font-size: 1.5rem;
}

.panel-tutorial strong {
    font-family: 'Roboto-Bold';
    color: #0099ff;
}

.bang-thanks {
    font-family: 'FS Ariston Comic Base' !important;
    color: #3b8d26 !important;
    font-size: 2.5rem !important;
    line-height: 2rem !important;
    max-width: 780px !important;
    margin-top: 20px !important;
}

.time-list {
    margin-top: 60px;
}

.time-item.checked .checkbox .check-right {
    background-color: #0099ff;
    border: 3px solid #003995;
}

.time-item.checked .checkbox .check-left {
    border: 3px solid #003995;
    position: relative;
}

.time-item.checked .checkbox .check-left:before {
    position: absolute;
    content: '';
    background: url(../../assets/check.png);
    background-size: contain;
    width: 47px;
    height: 47px;
    top: 0;
    left: 0;
    background-repeat: no-repeat;
}

</style>

<style>

</style>